import { Component, OnDestroy, OnInit } from '@angular/core'
import { ProductListComponentService } from '@spartacus/storefront'
import { Subscription } from 'rxjs'
import { ProductSearchPage } from '@spartacus/core'
import { SearchUtilsService } from '../../services/search-utils.service'
import { SmartSearchService } from '../../../cms/services/cms-search/smart-search.service'
import { withLatestFrom } from 'rxjs/operators'
import { Page } from 'smartsearch.js'

@Component({
  selector: 'mb-search-empty-result-component',
  templateUrl: './mb-search-empty-result.component.html',
  styleUrls: ['./mb-search-empty-result.component.scss']
})
export class MbSearchEmptyResultComponent implements OnInit, OnDestroy {

  subscription: Subscription = new Subscription()
  foundSearchResults: boolean = true
  foundCmsSearchResults: boolean = true
  hasQueryText: boolean = true
  showContentTab: boolean = false

  constructor (private productListComponentService: ProductListComponentService,
               private contentListComponentService: SmartSearchService,
               private searchUtilsService: SearchUtilsService) {
  }

  ngOnInit (): void {
    this.subscription.add(this.productListComponentService.model$
      .subscribe((model: ProductSearchPage) => {
        this.foundSearchResults = (model?.pagination?.totalResults && model?.pagination?.totalResults > 0) as boolean
        this.hasQueryText = !!model?.freeTextSearch || !!model?.currentQuery?.query?.value
      }))

    this.subscription.add(this.contentListComponentService.model$
      .subscribe((model: Page | undefined) => {
        this.foundCmsSearchResults = (model?.numberOfResults && model?.numberOfResults > 0) as boolean
      }))

    this.subscription.add(this.contentListComponentService.showContentTab$.pipe(
      withLatestFrom(this.searchUtilsService.isFacetsExpandedFromOutside$, this.searchUtilsService.isFacetsExpanded$)
    ).subscribe(([showContentTab, isFacetsVisibleTriggeredFromOutside, isFacetsVisible]: [boolean, boolean, boolean]) => {
      this.showContentTab = showContentTab
      if (this.showContentTab) {
        if (!this.foundCmsSearchResults && (isFacetsVisible || isFacetsVisibleTriggeredFromOutside)) {
          this.searchUtilsService.toggleFacetsFromOutside(false)
        }
      } else {
        if (!this.foundSearchResults && this.hasQueryText && (isFacetsVisible || isFacetsVisibleTriggeredFromOutside)) {
          this.searchUtilsService.toggleFacetsFromOutside(false)
        }
      }
    }))
  }

  ngOnDestroy (): void {
    this.subscription?.unsubscribe()
  }
}
